import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionReveal } from './SectionReveal';
const faqs = [{
  q: '¿Cómo recibo el pack después de abonar?',
  a: 'Apenas se acredita el pago por Mercado Pago recibís un correo con el link de descarga. Acceso inmediato desde cualquier dispositivo. No hay aprobación manual ni tiempo de espera.'
}, {
  q: '¿Sirve si trabajo con distintos tipos de sujetos obligados?',
  a: 'Sí. El pack está organizado por categoría de sujeto obligado — no es un documento genérico. El checklist, los modelos y el cronograma contemplan las diferencias entre directores de SA, gerentes de SRL, abogados por honorarios judiciales, colegios privados y prepagas. Si tu cartera tiene más de una categoría, todo está cubierto.'
}, {
  q: '¿Qué pasa si ARCA modifica plazos o incorpora nuevos obligados?',
  a: 'El pack incluye acceso a actualizaciones. Si la resolución se modifica o ARCA emite una norma complementaria relevante, recibís la versión actualizada sin costo adicional a la dirección informada en la compra.'
}, {
  q: '¿Esto me explica qué dice la RG 5866 o es solo material operativo?',
  a: 'Es material 100% operativo. No es una capacitación ni un análisis de la norma — ese trabajo ya lo hiciste. Es el paso siguiente: hacer el Encuadre de tu cartera, notificar a cada sujeto obligado y documentar todo antes de los primeros vencimientos.'
}, {
  q: '¿Tiene garantía real o es solo marketing?',
  a: '7 días, devolución del 100%, sin formularios. Si abrís el pack y no es lo que esperabas, escribís a [email de soporte] y te devolvemos el importe. Sin preguntas.'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-base" data-id="element-53" data-mp="3jz1cjvy167bi">
      <div className="mx-auto max-w-2xl px-5 py-16 md:py-20" data-id="element-54" data-mp="3k0ccfkocuuxc">
        <SectionReveal data-id="element-55" data-mp="3nya4cv9ifv4f">
          <h2 className="text-center text-2xl font-black leading-tight text-ink sm:text-3xl md:text-4xl" data-id="element-56" data-mp="3o1o5k06ftyaa">
            Lo que más nos preguntan
          </h2>
        </SectionReveal>

        <div className="mt-8 space-y-3" data-id="element-57" data-mp="1pojoaxxd2y04">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <SectionReveal key={i} delay={i * 0.04} data-id="element-58" data-mp="1fryiiadipiv8" data-mpi={i}>
                <div className="overflow-hidden rounded-xl border border-alt bg-base shadow-sm" data-id="element-59" data-mp="1ftjc9xs0cxs1">
                  <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left" data-id="element-60" data-mp="2df6wlkb6vpn7">
                    <span className="text-[15px] font-bold text-ink" data-id="element-61" data-mp="1zg7j98t4mx6c">
                      {faq.q}
                    </span>
                    <motion.span animate={{
                  rotate: isOpen ? 180 : 0
                }} transition={{
                  duration: 0.25
                }} data-id="element-62" data-mp="s3f89pawqw0i">
                      <ChevronDownIcon className="h-5 w-5 shrink-0 text-accent" data-id="element-63" data-mp="33ppilvorit82" />
                    </motion.span>
                  </button>
                  <AnimatePresence initial={false} data-id="element-64" data-mp="38nr8p0klvst1">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3,
                  ease: 'easeInOut'
                }} data-id="element-65" data-mp="3dfsmiqxf9rl6">
                        <p className="px-5 pb-5 text-[15px] leading-relaxed text-ink-soft" data-id="element-66" data-mp="220vs11igya6f">
                          {faq.a}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>
              </SectionReveal>;
        })}
        </div>
      </div>
    </section>;
}